import React from 'react';
import {
	Button,
	Checkbox,
	Form,
	Icon,
	Input,
	message,
	Dropdown,
	DatePicker,
	Menu,
	Upload,
	Select,
	Col,
	Layout,
	Row
} from 'antd';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as moment from 'moment';
import { auth, database } from '../firebase/firebase';
import HorizontalDefault from "./Topbar/HorizontalDefault/index";
import Moment from "moment";
import {version} from "util/config";

import { connect } from 'react-redux';
import {
	hideMessage,
	showAuthLoader,
	userFacebookSignIn,
	userGithubSignIn,
	userGoogleSignIn,
	userSignUp,
	userSignIn,
	userTwitterSignIn
} from 'appRedux/actions/Auth';

import IntlMessages from 'util/IntlMessages';
import CircularProgress from 'components/CircularProgress/index';


const FormItem = Form.Item;
const Option = Select.Option;
const codes = [
	"Lundbeck2025",
	"LUNDBECK2025",
	"Lundbeck",
	"LUNDBECK",
	"LUNDBECK1",
	"Lundbeck2026",
	"LUNDBECK2026",
	"Lundbeck2027",
	"LUNDBECK2027",
	"MHE",
	"LUNDBECK01",
	"LUNDBECK02",
	"LUNDBECK03",
	"LUNDBECK04",
	"LUNDBECK05",
	"LUNDBECK06",
	"LUNDBECK07",
	"LUNDBECK08",
	"LUNDBECK09",
	"LUNDBECK10",
	"LUNDBECK11",
	"LUNDBECK12",
	"LUNDBECK13",
	"LUNDBECK14",
	"LUNDBECK15",
	"LUNDBECK16",
	"LUNDBECK17",
	"LUNDBECK18",
	"LUNDBECK19",
	"LUNDBECK20",
	"LUNDBECK21",
	"LUNDBECK22",
	"LUNDBECK23",
	"LUNDBECK24",
	"LUNDBECK25",
	"LUNDBECK26",
	"LUNDBECK27",
	"LUNDBECK28",
	"LUNDBECK29",
	"LUNDBECK30",
	"LUNDBECK31",
	"LUNDBECK32",
	"LUNDBECK33",
	"LUNDBECK34",
	"LUNDBECK35",
	"LUNDBECK36",
	"LUNDBECK37",
	"LUNDBECK38",
	"LUNDBECK39",
	"LUNDBECK40",
	"LUNDBECK41",
	"LUNDBECK42",
	"LUNDBECK43",
	"LUNDBECK44",
	"LUNDBECK45",
	"LUNDBECK46",
	"LUNDBECK47",
	"LUNDBECK48",
	"LUNDBECK49",
	"LUNDBECK50",
	"LUNDBECK51",
	"LUNDBECK52",
	"LUNDBECK53",
	"LUNDBECK54",
	"LUNDBECK55",
	"LUNDBECK56",
	"LUNDBECK57",
	"LUNDBECK58",
	"LUNDBECK59",
	"LUNDBECK60",
	"LUNDBECK61",
	"LUNDBECK62",
	"LUNDBECK63",
	"LUNDBECK64",
	"LUNDBECK65",
	"LUNDBECK66",
	"LUNDBECK67",
	"LUNDBECK68",
	"LUNDBECK69",
	"LUNDBECK70",
	"LUNDBECK71",
	"LUNDBECK72",
	"LUNDBECK73",
	"LUNDBECK74",
	"LUNDBECK75",
	"LUNDBECK76",
	"LUNDBECK77",
	"LUNDBECK78",
	"LUNDBECK79",
	"LUNDBECK80",
	"LUNDBECK81",
	"LUNDBECK82",
	"LUNDBECK83",
	"LUNDBECK84",
	"LUNDBECK85",
	"LUNDBECK86",
	"LUNDBECK87",
	"LUNDBECK88",
	"LUNDBECK89",
	"LUNDBECK90",
	"LUNDBECK91",
	"LUNDBECK92",
	"LUNDBECK93",
	"LUNDBECK94",
	"LUNDBECK95",
	"LUNDBECK96",
	"LUNDBECK97",
	"LUNDBECK98",
	"LUNDBECK99",
	"LUNDBECK100",
	"INTERSISTEMAS",
	"INTERSISTEMAS001",
	"INTERSISTEMAS002",
	"INTERSISTEMAS003",
	"INTERSISTEMAS004",
	"INTERSISTEMAS005",
	"INTERSISTEMAS006",
	"INTERSISTEMAS007",
	"INTERSISTEMAS008",
	"INTERSISTEMAS009",
	"INTERSISTEMAS010",
	"INTERSISTEMAS011",
	"INTERSISTEMAS012",
	"INTERSISTEMAS013",
	"INTERSISTEMAS014",
	"INTERSISTEMAS015",
	"INTERSISTEMAS016",
	"INTERSISTEMAS017",
	"INTERSISTEMAS018",
	"INTERSISTEMAS019",
	"INTERSISTEMAS020",
	"INTERSISTEMAS021",
	"INTERSISTEMAS022",
	"INTERSISTEMAS023",
	"INTERSISTEMAS024",
	"INTERSISTEMAS025",
	"INTERSISTEMAS026",
	"INTERSISTEMAS027",
	"INTERSISTEMAS028",
	"INTERSISTEMAS029",
	"INTERSISTEMAS030",
	]

function getBase64(img, callback) {
	const reader = new FileReader();
	reader.addEventListener('load', () => callback(reader.result));
	reader.readAsDataURL(img);
}

function beforeUpload(file) {
	const isJPG = file.type === 'image/jpeg';
	if (!isJPG) {
		message.error('You can only upload JPG file!');
	}
	const isLt2M = file.size / 1024 / 1024 < 2;
	if (!isLt2M) {
		message.error('Image must smaller than 2MB!');
	}
	return isJPG && isLt2M;
}

class SignUp extends React.Component {
	handleChange = (info) => {
		if (info.file.status === 'uploading') {
			this.setState({ loading: true });
			return;
		}
		if (info.file.status === 'done') {
			// Get this url from response in real world.
			getBase64(info.file.originFileObj, (imageUrl) =>
				this.setState({
					imageUrl,
					loading: false
				})
			);
		}
	};
	handleInputChange(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ isGoing: e });
	}
	handleSessionChange(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ onSession: e });
	}
	handleCodeClick(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ code: e });
	

	}
	handleStateClick(e) {
		this.setState({ state: e });
	}
	handleSpecialtyClick(e) {
		this.setState({ speciality: e });
	}
	handleSexClick(e) {
		//console.log(e);
		//console.log(e);
		this.setState({ sex: e });
	}
	setRedirect = () => {
		this.setState({
			redirect: true
		});
	};
	renderRedirect = () => {
		if (this.state.redirect) {
			return <Redirect to="/profile" />;
		}
	};

	handleSignIn = (err, values) => {
		//console.log('data');
		//console.log(err);
		//console.log(values);
		if (!err) {
			var _this = this;
		
		
			//console.log('CALLING IF');
			if (values.avatar) {
				values.avatar = 'https://firebasestorage.googleapis.com/v0/b/curso-demencia.appspot.com/o/avatar-doctor.jpg?alt=media';
			}
			if (values.other_speciality === undefined ) {
				values.other_speciality = '';
			}
			if (!values.other_speciality) {
				values.other_speciality = '';
			}
			
			if (values.city === undefined) {
				values.city = ""
			}
			if (values.phone === undefined) {
				values.phone = ""
			}
			//if(this.state.isGoing == false){
			//if(values.age)
			//this.setState({ sex: values.sex});
			this.setState({ code: values.code});
			this.setState({ sex: values.sex });

			if(codes.indexOf(values.code) != -1){
			this.setState({  state: values.state });
			//console.log('CALLING LOADER');
			//this.props.showAuthLoader();
			
			this.setState({ values: values });
			var age = values.age
			values.age = age.format("DD/MM/YYYY")		
			values.email = values.email.trim().toLowerCase()
			
			//console.log(values);
			database.collection('users').where('email', '==', values.email).get().then(function(snapshot) {
				if (snapshot.docs.length == 0) {
					//console.log(Moment().format("DD/MM/YYYY'T'hh:mm:ss"))
					if(values.password.length >= 6){
					values.registration_date = Moment().format("DD/MM/YYYY'T'hh:mm:ss")
					
					database
						.collection('users')
						.add(values)
						.then(function(docRef) {
							//console.log('WRITING USER DATA DONE');
							_this.props.userSignUp(values);
						})
						.catch(function(error) {
							//console.error('Error adding document: ', error);
						});
				} else {
					//console.log('Short Password');
					message.error('La contraseña debe de tener al menos 6 caracteres');

					//_this.props.alertMessage = 'Este usuario ya esta registrado';
				}
			}else{
				message.error('Este usuario ya esta registrado');
			
			}
			});
		}else{
			message.error('Código de acceso inválido');
		}
		
	
		} else {
			//console.log('ERROR IS NOT NULL');
		}
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			this.handleSignIn(err, values);
			//console.log(moment(values.birthdate).format('MM/DD/YYYY'));
		});
	};

	constructor() {
		super();
		this.state = {
			loading: false,
			state: 'Aguascalientes',
			sex: 'Masculino',
			code: 'hablemosdepsiquiatria-lundbeck1',

			redirect: false,
			signing: false,
			values: {}
			//email: 'demo@example.com',
			//password: 'demo#123'
		};
		this.handleSubmit = this.handleSubmit.bind(this);
		this.setRedirect = this.setRedirect.bind(this);
		this.handleSignIn = this.handleSignIn.bind(this);
		this.handleCodeClick = this.handleCodeClick.bind(this);
		this.handleSpecialtyClick= this.handleSpecialtyClick.bind(this);
		this.handleSexClick = this.handleSexClick.bind(this);

		this.handleStateClick = this.handleStateClick.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSessionChange = this.handleSessionChange.bind(this);

	}

	componentDidMount() {
		this.setState({ state: 'Aguascalientes',  code:"ZATHELO1", isGoing: true, onSession:true });
	}

	componentDidUpdate() {
		//console.log("V1.233")
		if (this.props.showMessage) {
			setTimeout(() => {
				this.props.hideMessage();
			}, 100);
		}

		//console.log(this.props);
		//console.log(this.state);
		if (!this.state.signing) {
			if (this.props.authUser !== null) {
				auth.onAuthStateChanged((user) => {
					if (user) {
						//console.log('AUTH USER IS ALL RIGHT');
						//this.props.history.push('/');
						//console.log('redirecting...');
						this.setRedirect();
					} else {
						if (this.state.values.email && this.state.values.password) {
							var _this = this;
							this.setState({ signing: true });
							//console.log(this.props.authUser);
							//console.log('AUTH USER IS NOT NUL BUT FIREBASE IS; SIGNING IN....');
							auth
								.signInWithEmailAndPassword(this.state.values.email, this.state.values.password)
								.then((authUser) => {
									this.props.history.push('//');
								})
								.catch((error) => error);
						} else {
							//console.log('EMPTY VALUES');
						}
					}
				});
			} else {
				//console.log('AUTH USER IS NULL');
			}
		}
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		const { showMessage, loader, alertMessage } = this.props;

		const imageUrl = this.state.imageUrl;
		return (
			<div className="gx-app-login-wrap" >
			<HorizontalDefault/>
			<div className="gx-app-login-wrap" id="login-cont">
			<br></br>	<br></br>	<br></br>	<br></br>			<br></br>	<br></br>	<br></br>	<br></br>			<br></br>	<br></br>	<br></br>	<br></br>
			<br></br>	<br></br>	<br></br>	<br></br><br></br>	<br></br>	<br></br>	<br></br>
				<div className="gx-app-login-container">
				
					<div className="gx-app-login-main-content">
						
						{this.renderRedirect()}

						<div className="gx-app-login-content">
						<Row><Col span="8"></Col><Col span="12">		
						<img alt="example" src={require('assets/images/asset_3.png')} /> 	<br></br>	<br></br>	<br></br>
						</Col><Col span="6"></Col>
					
						</Row>
							{/* <Row>
								<Col span="8" />
								<Col span="8">
									{' '}
								 <img alt="example" src={require('assets/images/asset_3.png')} /> 
								</Col>
								<Col span="8" />
							</Row>
							<br /> */}
							<Form onSubmit={this.handleSubmit} className="gx-signup-form gx-form-row0">
								<Row>
									<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										<FormItem>
											{getFieldDecorator('name', {
												rules: [ { required: true, message: 'Por favor escribe tu nombre' } ]
											})(<Input placeholder="Nombre" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('paternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido paterno' } ]
											})(<Input placeholder="Apellido Paterno" />)}
										</FormItem>

										<FormItem>
											{getFieldDecorator('maternal_lastname', {
												rules: [ { required: true, message: 'Ingrese su apellido materno' } ]
											})(<Input placeholder="Apellido Materno" />)}
										</FormItem>
										
										<FormItem>
												{getFieldDecorator('sex', {
													rules: [{ required: true, message: 'Por favor seleccione su sexo' }]
												})(
													<Select
														name="sex"
														onChange={this.handleSexClick}
														value={this.state.sex}
														placeholder="Sexo"
													>
														<Option value="Masculino">Masculino</Option>
														<Option value="Femenino">Femenino</Option>
													</Select>
												)}
											</FormItem>
											<FormItem>
												{getFieldDecorator('age', {
													rules: [
														{
															required: true,
															message: 'Por favor seleccione su fecha de nacimiento'
														}
													]
												})(
													<DatePicker
														className="gx-mb-3 gx-w-100"
														showTime={false}
														showToday={false}
														format="DD/MM/YYYY"
														placeholder="Fecha de nacimiento"
													/>
												)}
											</FormItem>


							
										<FormItem>
											{getFieldDecorator('country', {
												rules: [ { required: true, message: 'Por favor ingrese su país' } ]
											})(
												<Select
													name="country"
													onChange={this.handleStateClick}
													value={this.state.state}
													placeholder="País"
												>
													<Option value="México">México</Option>

													<Option value="Colombia">Colombia</Option>

													<Option value="Panamá">Panamá</Option>

													<Option value="Guatemala">Guatemala</Option>
													<Option value="Chile">Chile</Option>
													<Option value="Argentina">Argentina</Option>

													<Option value="República Dominicana">República Dominicana</Option>

													<Option value="Costa Rica">Costa Rica</Option>

													<Option value="El_Salvador">El Salvador
													</Option>

													<Option value="Nicaragua">Nicaragua</Option>

													<Option value="Honduras">Honduras</Option>

												</Select>
											)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('state', {
												rules: [ { required: true, message: 'Ingrese su Estado' } ]
											})(<Input placeholder="Estado" />)}
										</FormItem>
										{/* <FormItem>
											{getFieldDecorator('city', {
												rules: [ { required: true, message: 'Ingrese su ciudad' } ]
											})(<Input placeholder="Ciudad" />)}
										</FormItem> */}
										<FormItem>
									{getFieldDecorator('onSession', {
										rules: [ { required: false, message: 'para mantener la sesión abierta' } ],
										valuePropName: 'checked',
										initialValue: true
									})(
										<Input
										name="onSession"
										type="checkbox"
										checked={this.state.onSession}
										onChange={this.handleInputChange} ></Input>
								
									)}
									
									<span className="gx-link gx-signup-form-forgot">
									&nbsp; Mantener sesión abierta
									</span>
								</FormItem>
								
														
										</Col>
												<Col xl={12} lg={12} md={12} sm={12} xs={12}>
										
									
										<FormItem>
											{getFieldDecorator('license', {
												rules: [ { required: true, message: 'Ingrese su cédula profesional' } ]
											})(<Input placeholder="Ingrese su cédula profesional" />)}
										</FormItem>	
										<FormItem>
											{getFieldDecorator('speciality', {
												rules: [ { required: true, message: 'Por favor seleccione su especialidad' } ]
											})(
												<Select
													name="speciality"
													onChange={this.handleSpecialtyClick}
													value={this.state.speciality}
													placeholder="Especialidad"
												>

													<Option value="Residente">Residente</Option>

													<Option value="Medicina General">Medicina General</Option>

													<Option value="Médico Internista">Médico Internista</Option>

													<Option value="Psiquiatra">Psiquiatra</Option>

													<Option value="Otra ">Otra Especialidad</Option>
												</Select>
											)}
										</FormItem>

										
										<FormItem>
											{getFieldDecorator('other_speciality', {
												rules: [ { required: false, message: 'Ingrese otra especialidad' } ]
											})(<Input placeholder="Otra especialidad (si aplica)" />)}
										</FormItem>	
										
										<FormItem>
											{getFieldDecorator('code', {
												rules: [ { required: true, message: 'Ingrese su Clave de acceso' } ]
											})(<Input placeholder="Ingrese su Clave de acceso" />)}
										</FormItem>	
										<FormItem>
												{getFieldDecorator('phone', {
													rules: [{ required: true, message: 'Ingrese su teléfono' }]
												})(<Input placeholder="Ingrese su teléfono" />)}
											</FormItem>

								
														
										{/* <span>Fotografía de perfil</span> */}

										{/* <FormItem>
									{getFieldDecorator('avatar', {
										rules: [
											{
												required: false,
												message: 'Please upload your avatar!'
											}
										]
									})(
										<Upload
											name="avatar"
											listType="picture-card"
											className="avatar-uploader"
											showUploadList={false}
											//action="//jsonplaceholder.typicode.com/posts/"
											beforeUpload={this.beforeUpload}
											onChange={this.handleChange}
										>
											{imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
										</Upload>
									)}
								</FormItem> */}
										<FormItem>
											{getFieldDecorator('email', {
												rules: [
													{
														required: true,
														type: 'email',
														message: 'The input is not valid E-mail!'
													}
												]
											})(<Input placeholder="Email" />)}
										</FormItem>
										<FormItem>
											{getFieldDecorator('password', {
												rules: [ { required: true, message: 'Por favor escribe tu contraseña' } ]
											})(<Input type="password" placeholder="Password" />)}
										</FormItem>

									</Col>
								</Row>
							
								<FormItem>
									{getFieldDecorator('remember', {
										rules: [ { required: true, message: 'Debes aceptar los términos y condiciones' } ],
										valuePropName: 'checked',
										initialValue: true
									})(
										<Input
										name="isGoing"
										type="checkbox"
										checked={this.state.isGoing}
										onChange={this.handleInputChange} ></Input>
								
									)}
									
									<span className="gx-link gx-signup-form-forgot short-line-height">
										<i> Mediante mi suscripción y registro al Sitio confirmo que soy un Profesional de la Salud autorizado para practicar la profesión de Médico y autorizo a <b>Lundbeck México, S.A. de C.V.</b>, con domicilio en Av. Insurgentes Sur 1457, piso 14 de la Torre Manacar, colonia Insurgentes Mixcoac, alcaldía Benito Juárez, C.P. 03920 Ciudad de México, México, al tratamiento de mis datos personales en torno al registro que estoy realizando y para las finalidades que se establecen en el Aviso de Privacidad Integral disponible en: </i><a className="gx-login-form-forgot" href="https://www.hablemosdepsiquiatria.com/aviso" target="_blank">https://www.hablemosdepsiquiatria.com/aviso	</a>así como de conformidad al Aviso Legal disponible en el mismo enlace.
									</span>
								</FormItem>
								
								<FormItem>
									<Button
									id="sesion"
										type="primary"
										className="gx-mb-0"
										htmlType="submit"
										onClick={this.handleSubmit}
									>
										<IntlMessages id="app.userAuth.signUp" />
									</Button>
									<span>
										<IntlMessages id="app.userAuth.or" />
									</span>{' '}
									<Link to="/signin">
										<IntlMessages id="app.userAuth.signIn" />
									</Link>
								</FormItem>
							</Form>
						</div>
					

						{loader && (
							<div className="gx-loader-view">
								<CircularProgress />
							</div>
						)}
						{showMessage && message.error(alertMessage)}
					</div>
					<span id="version-code">
				{version}</span>
				</div>
				<br></br>	<br></br>	<br></br>	<br></br>	<br></br>	<br></br>	<br></br>	<br></br>	<br></br>

				</div>
 
			</div>
		);
	}
}

const WrappedSignUpForm = Form.create()(SignUp);

const mapStateToProps = ({ auth }) => {
	const { loader, alertMessage, showMessage, authUser } = auth;
	return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps, {
	userSignUp,
	hideMessage,
	userSignIn,
	showAuthLoader,
	userFacebookSignIn,
	userGoogleSignIn,
	userGithubSignIn,
	userTwitterSignIn
})(WrappedSignUpForm);
